import { addResourceIfNotExists } from '../utils/resource.utils';
import { generateAnimationId } from '@/utils/generate-id';
import { easings } from '@/resources/easings';

const genEase = (detail: IAnimation) => {
  const { easeType, duration } = detail;
  const cubicBezierItem = easings.find((item) => item.name === easeType);

  if (!cubicBezierItem) return [];
  const { cubicBezier } = cubicBezierItem;
  // 第二个参数是时间
  const param1 = (duration || 0) / 1000;

  const ease = ['cubic-bezier', param1];
  const params = cubicBezier
    .split(',')
    .map((item) => item.trim())
    .map((item) => parseFloat(item));
  ease.push(...params);
  return ease;
};
const getAttr = (animation: IAnimation): string => {
  // TODO 获取动画效果，这部分目前还没有支持，故而可以为空
  const opacity = (animation.alpha === undefined ? 100 : animation.alpha) / 100;
  const toOpacity =
    (animation.toAlpha === undefined ? 100 : animation.toAlpha) / 100;
  const delay = (animation.delay || 0) / 1000;
  const duration = (animation.duration || 300) / 1000;

  const map: {
    [key in Exclude<IAnimation['type'], 'show'>]: (
      detail: IAnimation
    ) => IDataItemAnimationAttr;
  } = {
    alpha: () => {
      return {
        id: generateAnimationId(),
        fromState: {
          opacity
        },
        toState: {
          opacity: toOpacity
        },
        config: {
          delay,
          duration,
          direction: 'normal',
          ratio: 1, // TODO 这个倍数还没有关联起来
          iterations: 0 // TODO 这个循环次数也还没有关联起来
        }
      };
    },
    position: (detail: IAnimation) => {
      const { translateX = 0, translateY = 0 } = detail;
      const res: IDataItemAnimationAttr = {
        id: generateAnimationId(),
        toState: {
          // 工具中translate_x y是相对坐标
          // 在vela中x y是相对坐标
          x: translateX,
          y: translateY
        },
        config: {
          delay,
          duration,
          direction: 'normal',
          ratio: 1, // TODO 这个倍数还没有关联起来
          iterations: 0 // TODO 这个循环次数也还没有关联起来
        }
      };
      return res;
    },
    scale: (detail: IAnimation) => {
      const scale = (detail.scale || 100) / 100;
      return {
        id: generateAnimationId(),
        toState: {
          scale
        },
        config: {
          delay,
          duration,
          direction: 'normal',
          ratio: 1, // TODO 这个倍数还没有关联起来
          iterations: 0 // TODO 这个循环次数也还没有关联起来
        }
      };
    },
    rotation: (detail: IAnimation) => {
      return {
        id: generateAnimationId(),
        fromState: {
          rotate: 0
        },
        toState: {
          rotate: detail.rotation
        },
        config: {
          delay,
          duration,
          direction: 'normal',
          ratio: 1, // TODO 这个倍数还没有关联起来
          iterations: 0 // TODO 这个循环次数也还没有关联起来
        }
      };
    }
  };
  const { type } = animation;
  const func = map[type as Exclude<IAnimation['type'], 'show'>];
  const attr: IDataItemAnimationAttr = func
    ? func(animation)
    : { id: 1, toState: {}, config: {} };

  attr.config.ease = genEase(animation);
  return JSON.stringify(attr).replaceAll('"', '&quot;');
};

export const bindWidgetAnimation = (
  resourceAst: Ast,
  shapeIds: string[],
  animation: Ast,
  condition: Ast,
  shapeLayoutAst: Ast[]
) => {
  // 从图层当中过滤出绑定了动画的部分
  const layoutsAst = shapeLayoutAst.filter((shapeAst) => {
    return shapeIds.includes(shapeAst.attrsMap._id);
  });

  const widget: Ast = addResourceIfNotExists(resourceAst, {
    tag: 'Widget',
    attrsMap: {
      condition: `@${condition.attrsMap.name}`
    },
    children: layoutsAst.map((ast) => ({
      tag: 'Item',
      attrsMap: {
        ref: ast.attrsMap.ref,
        animation: `@${animation.attrsMap.name}`,
        _id: ast.attrsMap._id,
        // 动画继承父元素缩放/透明度，保证在画布中展示正确
        _alpha: layoutsAst[0].attrsMap._alpha,
        _scale: layoutsAst[0].attrsMap._scale
      },
      children: []
    }))
  });

  // 将这些图层的ref指向widget
  layoutsAst.forEach((ast) => {
    ast.attrsMap.ref = `@${widget.attrsMap.name}`;
    ast.attrsMap._name = 'ifttt使用';
    ast.attrsMap._id = 'ifttt_' + ast.attrsMap._id;
  });

  return widget;
};

export const getAnimationAst = (
  resourceAst: Ast,
  animations: IAnimation[],
  ifttt: IFTTT
) => {
  // 需要重新处理一下，如果是显示隐藏的，也就是detail.type === 'show'的，需要创建出solt进行显示隐藏控制, 并且animation可以不用编写进xml
  // 如果是其他的，需要跟动画绑定使用
  const { shapeId } = ifttt;
  const children = animations.map((animation) => {
    return {
      tag: 'Item',
      attrsMap: {
        attr: getAttr(animation),
        _aniId: animation.id
      },
      children: []
    } as Ast;
  });
  if (!children.length) return null;
  return addResourceIfNotExists(
    resourceAst,
    {
      tag: 'Animation',
      attrsMap: {
        name: `Animation`, // TODO 动画名称需要考虑一下
        selectMethod: 'inOrder', // TODO 这地方动画选择需要再考虑一下
        _shapeId: shapeId,
        _iftttId: ifttt.id
      },
      children: children.filter((item) => !!item) || []
    }
    // undefined,
    // true
  );
};
